export const getFormData = () => {
  const companyInfoFields = [
    {
      id: "companyName",
      placeholder: "Company Name*",
    },
    {
      id: "legalName",
      placeholder: "Legal Name",
    },
    {
      id: "tradeName",
      placeholder: "Trade Name",
    },
    {
      id: "registrationNumber",
      placeholder: "Registration Number",
      type: "text",
    },
    {
      id: "dateOfIncorporation",
      placeholder: "Date of Incorporation",
      type: "date",
    },
    {
      id: "countryOfIncorporation",
      placeholder: "Country of Incorporation",
      type: "text",
    },
    {
      id: "registeredOfficeAddress",
      placeholder: "Registered Office Address",
      type: "text",
    },
    {
      id: "operatingOfficeAddress",
      placeholder: "Operating Office Address (if different)",
      type: "text",
    },
    {
      id: "city",
      placeholder: "City",
      type: "text",
    },
    {
      id: "stateProvince",
      placeholder: "State/Province",
      type: "text",
    },
    {
      id: "postalZipCode",
      placeholder: "Postal/Zip Code",
      type: "text",
    },
    {
      id: "country",
      placeholder: "Country",
      type: "text",
    },
    {
      id: "primaryContactPerson",
      placeholder: "Primary Contact Person",
      type: "text",
    },
    {
      id: "positionTitle",
      placeholder: "Position/Title",
      type: "text",
    },
    {
      id: "phoneNumber",
      placeholder: "Phone Number",
      type: "text",
    },
    {
      id: "emailAddress",
      placeholder: "Email Address",
      type: "text",
    },
    {
      id: "faxNumber",
      placeholder: "Fax Number (if any)",
      type: "text",
    },
    // Add more fields as needed
  ];

  const companyTypeOptions = [
    {
      value: "public-limited",
      label: "Public Limited",
    },
    {
      value: "private-limited",
      label: "Private Limited",
    },
    {
      value: "partnership",
      label: "Partnership",
    },
    {
      value: "sole-proprietorship",
      label: "Sole Proprietorship",
    },
  ];

  const businessInfoFields = [
    {
      id: "natureOfBusiness",
      placeholder: "Nature of Business",
      type: "text",
    },
    {
      id: "industry",
      placeholder: "Industry",
      type: "text",
    },
    {
      id: "mainActivities",
      placeholder: "Main Activities",
      type: "text",
    },
    {
      id: "productsServicesOffered",
      placeholder: "Products/Services Offered",
      type: "text",
    },
    // Add more fields as needed
  ];

  const operationalInfo = [
    {
      id: "numberOfEmployees",
      placeholder: "Number of Employees",
      type: "text",
    },
    {
      id: "annualTurnover",
      placeholder: "Annual Turnover",
      type: "text",
    },
    {
      id: "majorMarkets",
      placeholder: "Major Markets (Geographic Regions)",
      type: "text",
    },
    {
      id: "businessStructure",
      placeholder: "Business Structure",
      type: "text",
    },
    {
      id: "parentCompany",
      placeholder: "Parent Company (if any)",
      type: "text",
    },
    {
      id: "subsidiaries",
      placeholder: "Subsidiaries (if any)",
      type: "text",
    },
    {
      id: "affiliates",
      placeholder: "Affiliates (if any)",
      type: "text",
    },
  ];

  const ownerInfoFields = [
    {
      id: "name",
      placeholder: "Name",
      type: "text",
      category: "owner",
    },
    {
      id: "nationality",
      placeholder: "Nationality",
      type: "text",
      category: "owner",
    },
    {
      id: "percentageOfOwnership",
      placeholder: "Percentage of Ownership",
      type: "text",
      category: "owner",
    },
    {
      id: "contactDetails",
      placeholder: "Contact Details",
      type: "number",
      category: "owner",
    },
    // Director/Key management personnel fields
  ];

  const directorInfoFields = [
    // Director/Key management personnel fields
    {
      id: "name",
      placeholder: "Name",
      type: "text",
      category: "director",
    },
    {
      id: "position",
      placeholder: "Position",
      type: "text",
      category: "director",
    },
    {
      id: "nationality",
      placeholder: "Nationality",
      type: "text",
      category: "director",
    },
    {
      id: "contactDetails",
      placeholder: "Contact Details",
      type: "text",
      category: "director",
    },
  ];

  const taxInfoFields = [
    {
      id: "taxIdentificationNumber",
      placeholder: "Tax Identification Number (TIN)",
      type: "text",
    },
    {
      id: "vatGstNumber",
      placeholder: "VAT/GST Number (if applicable)",
      type: "text",
    },
    {
      id: "countryOfTaxResidence",
      placeholder: "Country of Tax Residence",
      type: "text",
    },
    {
      id: "amlComplianceImplemented",
      placeholder: "Has the company implemented AML policies?",
      type: "radio",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    {
      id: "amlComplianceOfficerName",
      placeholder: "Name of AML Compliance Officer",
      type: "text",
    },
    {
      id: "amlComplianceOfficerContact",
      placeholder: "Contact Information of AML Compliance Officer",
      type: "text",
    },
  ];

  const bankingInfoFields = [
    {
      id: "primaryBank",
      placeholder: "Primary Bank",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "accountNumber",
      placeholder: "Account Number",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "bankAddress",
      placeholder: "Bank Address",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "swiftBicCode",
      placeholder: "SWIFT/BIC Code",
      type: "text",
      grid: { xs: 4 },
    },
  ];

  // ### Supporting Documents

  // ```javascript
  const supportingDocumentsFields = [
    {
      id: "certificateOfIncorporation",
      name: "Certificate of Incorporation",
      label: "Certificate of Incorporation",
    },
    {
      id: "memorandumArticles",
      name: "Memorandum and Articles of Association",
      label: "Memorandum and Articles of Association",
    },
    {
      id: "annualReport",
      name: "Recent Annual Report or Financial Statement",
      label: "Recent Annual Report or Financial Statement",
    },
    {
      id: "identificationDocuments",
      name: "Identification Documents of Directors/Shareholders",
      label:
        "Identification Documents of Directors/Shareholders (e.g., Passport, National ID)",
    },
    {
      id: "proofOfAddress",
      name: "Proof of Address",
      label: "Proof of Address (e.g., Utility Bill, Bank Statement)",
    },
    {
      id: "taxComplianceCertificate",
      name: "Tax Compliance Certificate",
      label: "Tax Compliance Certificate (if applicable)",
    },
    {
      id: "amlPolicyDocument",
      name: "AML Policy Document",
      label: "AML Policy Document (if applicable)",
    },
  ];

  return {
    companyTypeOptions,
    companyInfoFields,
    businessInfoFields,
    operationalInfo,
    ownerInfoFields,
    directorInfoFields,
    taxInfoFields,
    bankingInfoFields,
    supportingDocumentsFields,
    // Add more sections as needed
  };
};

export const getProfessionalData = () => {
  const professionalInfoFields = [
    {
      name: "firstname",
      id: "firstName",
      placeholder: "First Name",
      type: "text",
    },
    {
      name: "middlename",
      id: "middleName",
      placeholder: "Middle Name",
      type: "text",
    },
    {
      name: "lastname",
      id: "lastName",
      placeholder: "Last Name",
      type: "text",
    },
    {
      name: "professionaltitle",
      id: "professionalTitle",
      placeholder: "Professional Title",
      type: "text",
    },
    {
      name: "dateofbirth",
      id: "dateOfBirth",
      placeholder: "Date of Birth",
      type: "date",
      InputLabelProps: {
        shrink: true,
      },
    },
    {
      name: "primarynationality",
      id: "primaryNationality",
      placeholder: "Primary Nationality",
      type: "text",
    },
    {
      name: "secondarynationality",
      id: "secondaryNationality",
      placeholder: "Secondary Nationality (if any)",
      type: "text",
    },
    {
      name: "streetaddress",
      id: "streetAddress",
      placeholder: "Street Address",
      type: "text",
    },
    {
      name: "city",
      id: "city",
      placeholder: "City",
      type: "text",
    },
    {
      name: "state",
      id: "state",
      placeholder: "State/Province",
      type: "text",
    },
    {
      name: "postalcode",
      id: "postalCode",
      placeholder: "Postal/Zip Code",
      type: "text",
    },
    {
      name: "country",
      id: "country",
      placeholder: "Country",
      type: "text",
    },
    {
      id: "mobilePhone",
      placeholder: "Mobile Phone",
      type: "text",
      name: "mobilephone",
    },
    {
      id: "officePhone",
      placeholder: "Office Phone",
      type: "text",
      name: "officephone",
    },
    {
      id: "homePhone",
      placeholder: "Home Phone",
      type: "text",
      name: "homephone",
    },
    {
      id: "personalEmail",
      placeholder: "Personal Email",
      type: "text",
      name: "personalemail",
    },
    {
      id: "professionalEmail",
      placeholder: "Professional Email",
      type: "text",
      name: "professionalemail",
    },
  ];

  const registrationInfoFields = [
    {
      id: "registrationNumber",
      placeholder: "Registration Number",
      type: "text",
      name: "registrationnumber",
    },
    {
      id: "dateOfRegistration",
      placeholder: "Date of Registration",
      type: "text",
      name: "dateofregistration",
    },
    {
      id: "issuingAuthority",
      placeholder: "Issuing Authority",
      type: "text",
      name: "issuingauthority",
    },
    {
      id: "countryOfRegistration",
      placeholder: "Country of Registration",
      type: "text",
      name: "countryofregistration",
    },
    {
      id: "professionalMemberships",
      placeholder: "Professional Memberships",
      type: "text",
      name: "professionalmemberships",
    },
    {
      id: "professionalBodies",
      placeholder: "Name of Professional Bodies/Associations",
      type: "text",
      name: "registrationnumber",
    },
    {
      id: "membershipNumbers",
      placeholder: "Membership Numbers",
      type: "text",
      name: "membershipnumber",
    },
    {
      id: "professionalExperience",
      placeholder: "Professional Experience",
      type: "text",
      name: "professionalexperience",
    },
    {
      id: "yearsOfExperience",
      placeholder: "Years of Experience",
      type: "text",
      name: "yearsofexperience",
    },
    {
      id: "areasOfSpecialization",
      placeholder: "Areas of Specialization",
      type: "text",
      name: "areasofspecialization",
    },
    {
      id: "currentEmployer",
      placeholder: "Current Employer/Practice Name",
      type: "text",
      name: "currentemployer",
    },
    {
      id: "previousEmployers",
      placeholder: "Previous Employers (last 5 years)",
      type: "text",
      name: "previousemployers",
    },
  ];
  const genderOptions = {
    id: "gender",
    label: "Gender",
    type: "radio",
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
      { value: "other", label: "Other" },
      { value: "prefernottosay", label: "Prefer Not to say" },
    ],
  };

  const taxInfoFields = [
    { id:"taxidentificationnumber",
      label: "Tax Identification Number (TIN)",
      placeholder: "Tax Identification Number (TIN)",
      type: "text",
    },
    {
      id:"vat/gstnumber",
      label: "VAT/GST Number (if applicable)",
      placeholder: "VAT/GST Number (if applicable)",
      type: "text",
    },
    {
      id:"countryoftaxresidence",
      label: "Country of Tax Residence",
      placeholder: "Country of Tax Residence",
      type: "text",
    },
    {
      id:"amlComplianceofficer",
      label: "Name of AML Compliance Officer",
      placeholder: "Name of AML Compliance Officer",
      type: "text",
    },
    {
      id:"contactofamlofficer ",
      label: "Contact Information of AML Compliance Officer",
      placeholder: "Contact Information of AML Compliance Officer",
      type: "text",
    },
  ];

  const bankDetailsFields = [
    {
      id:"primarybank",
      label: "Primary Bank",
      placeholder: "Primary Bank",
      type: "text",      
    },
    {
      id:"accountno.",
      label: "Account Number",
      placeholder: "Account Number",
      type: "text",     
    },
    {
      id:"bankaddress",
      label: "Bank Address",
      placeholder: "Bank Address",
      type: "text",     
    },
    {
      id:"swift/bic code",
      label: "SWIFT/BIC Code",
      placeholder: "SWIFT/BIC Code",
      type: "text",      
    },
  ];

  const supportingDocuments = [
    {
      id:"proofofidentity",
      name: "ProofofIdentity",
      label: "Proof of Identity (e.g., Passport, National ID)",
      type: "checkbox",
    },
    {
      id:"proofofaddress",
      name: "ProofofAddress",
      label: "Proof of Address (e.g., Utility Bill, Bank Statement)",
      type: "checkbox",
    },
    {
      id:"professionalqualificationcertificate",
      name: "PQC",
      label: "Professional Qualification Certificate",
      type: "checkbox",
    },
    {
      id:"professionalqualificationcertificate",
      name: "PRC",
      label: "Professional Qualification Certificate",
      type: "checkbox",
    },
    {
      id:"passportsizedphoto",
      name: "PassportSizedPhoto",
      label: "Recent Passport-Sized Photograph",
      type: "checkbox",
    },
    {
      id:"taxcompliancecertificate",
      name: "taxComplianceCertificate",
      label: "Tax Compliance Certificate (if applicable)",
      type: "checkbox",
    },
    {
      id:"amlpolicydocument",
      name: "amlPolicyDocument",
      label: "AML Policy Document (if applicable)",
      type: "checkbox",
    },
  ];

  return {
    professionalInfoFields,
    genderOptions,
    professionalInfoFields,
    registrationInfoFields,
    taxInfoFields,
    bankDetailsFields,
    supportingDocuments,
  };
};

export const getFirmData = () => {
  const firmFieldsData = [
    {
      id:"firmname",
      label: "Firm Name*",
      placeholder: "Firm Name*",
      type: "text",
    },
    {
      id:"legalname",
      label: "Legal Name",
      placeholder: "Legal Name",
      type: "text",
    },
    {
      id:"tradename",
      label: "Trade Name (if any)",
      placeholder: "Trade Name (if any)",
      type: "text",
    },
    {
      id: "registrationNumber",
      placeholder: "Registration Number",
      type: "text",
    },
    {
      id: "dateOfIncorporation",
      placeholder: "Date of Incorporation",
      type: "date",
    },
    {
      id: "countryOfIncorporation",
      placeholder: "Country of Incorporation",
      type: "text",
    },
    {
      id: "registeredOfficeAddress",
      placeholder: "Registered Office Address",
      type: "text",
    },
    {
      id: "operatingOfficeAddress",
      placeholder: "Operating Office Address (if different)",
      type: "text",
    },
    {
      id: "city",
      placeholder: "City",
      type: "text",
    },
    {
      id: "stateProvince",
      placeholder: "State/Province",
      type: "text",
    },
    {
      id: "postalZipCode",
      placeholder: "Postal/Zip Code",
      type: "text",
    },
    {
      id: "country",
      placeholder: "Country",
      type: "text",
    },
    {
      id: "primaryContactPerson",
      placeholder: "Primary Contact Person",
      type: "text",
    },
    {
      id: "positionTitle",
      placeholder: "Position/Title",
      type: "text",
    },
    {
      id: "phoneNumber",
      placeholder: "Phone Number",
      type: "text",
    },
    {
      id: "emailAddress",
      placeholder: "Email Address",
      type: "text",
    },
    {
      id: "faxNumber",
      placeholder: "Fax Number (if any)",
      type: "text",
    },
  ];

  const firmTypeOptions = [
    {
      value: "public-limited",
      label: "Public Limited",
    },
    {
      value: "private-limited",
      label: "Private Limited",
    },
    {
      value: "partnership",
      label: "Partnership",
    },
    {
      value: "sole-proprietorship",
      label: "Sole Proprietorship",
    },
    {
      value: "limited-liability-partnership",
      label: "Limited Liability Partnership",
    },
  ];

  const businessInfoFields = [
    {
      id: "natureOfBusiness",
      placeholder: "Nature of Business",
      type: "text",
    },
    {
      id: "industry",
      placeholder: "Industry Focus(if any)",
      type: "text",
    },
    {
      id: "mainActivities",
      placeholder:
        "Main Services Offered (e.g., Auditing, Taxation, Advisory, Bookkeeping)",
      type: "text",
    },
    // Add more fields as needed
  ];

  const operationalInfo = [
    {
      id: "numberOfEmployees",
      placeholder: "Number of Employees",
      type: "text",
    },
    {
      id: "annualTurnover",
      placeholder: "Annual Turnover",
      type: "text",
    },
    {
      id: "majorMarkets",
      placeholder: "Major Markets (Geographic Regions)",
      type: "text",
    },
    {
      id: "businessStructure",
      placeholder: "Business Structure",
      type: "text",
    },
    {
      id: "parentCompany",
      placeholder: "Parent Company (if any)",
      type: "text",
    },
    {
      id: "subsidiaries",
      placeholder: "Subsidiaries (if any)",
      type: "text",
    },
    {
      id: "affiliates",
      placeholder: "Affiliates (if any)",
      type: "text",
    },
  ];

  const ownerInfoFields = [
    {
      id: "name",
      placeholder: "Name",
      type: "text",
      category: "owner",
    },
    {
      id: "nationality",
      placeholder: "Nationality",
      type: "text",
      category: "owner",
    },
    {
      id: "percentageOfOwnership",
      placeholder: "Percentage of Ownership",
      type: "text",
      category: "owner",
    },
    {
      id: "contactDetails",
      placeholder: "Contact Details",
      type: "number",
      category: "owner",
    },
    // Director/Key management personnel fields
  ];

  const directorInfoFields = [
    // Director/Key management personnel fields
    {
      id: "name",
      placeholder: "Name",
      type: "text",
      category: "director",
    },
    {
      id: "position",
      placeholder: "Position",
      type: "text",
      category: "director",
    },
    {
      id: "nationality",
      placeholder: "Nationality",
      type: "text",
      category: "director",
    },
    {
      id: "contactDetails",
      placeholder: "Contact Details",
      type: "text",
      category: "director",
    },
  ];

  const taxInfoFields = [
    {
      id: "taxIdentificationNumber",
      placeholder: "Tax Identification Number (TIN)",
      type: "text",
    },
    {
      id: "vatGstNumber",
      placeholder: "VAT/GST Number (if applicable)",
      type: "text",
    },
    {
      id: "countryOfTaxResidence",
      placeholder: "Country of Tax Residence",
      type: "text",
    },
    {
      id: "amlComplianceImplemented",
      placeholder: "Has the company implemented AML policies?",
      type: "radio",
      options: [
        { value: "yes", label: "Yes" },
        { value: "no", label: "No" },
      ],
    },
    {
      id: "amlComplianceOfficerName",
      placeholder: "Name of AML Compliance Officer",
      type: "text",
    },
    {
      id: "amlComplianceOfficerContact",
      placeholder: "Contact Information of AML Compliance Officer",
      type: "text",
    },
  ];

  const bankingInfoFields = [
    {
      id: "primaryBank",
      placeholder: "Primary Bank",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "accountNumber",
      placeholder: "Account Number",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "bankAddress",
      placeholder: "Bank Address",
      type: "text",
      grid: { xs: 4 },
    },
    {
      id: "swiftBicCode",
      placeholder: "SWIFT/BIC Code",
      type: "text",
      grid: { xs: 4 },
    },
  ];

  const registrationInfoFields = [
    {
      id: "registrationNumber",
      placeholder: "Registration Number",
      type: "text",
      name: "registrationnumber",
    },
    {
      id: "dateOfRegistration",
      placeholder: "Date of Registration",
      type: "text",
      name: "dateofregistration",
    },
    {
      id: "issuingAuthority",
      placeholder: "Issuing Authority",
      type: "text",
      name: "issuingauthority",
    },
    {
      id: "countryOfRegistration",
      placeholder: "Country of Registration",
      type: "text",
      name: "countryofregistration",
    },
    {
      id: "professionalMemberships",
      placeholder: "Professional Memberships",
      type: "text",
      name: "professionalmemberships",
    },
    {
      id: "professionalBodies",
      placeholder: "Name of Professional Bodies/Associations",
      type: "text",
      name: "registrationnumber",
    },
    {
      id: "membershipNumbers",
      placeholder: "Membership Numbers",
      type: "text",
      name: "membershipnumber",
    },
    {
      id: "professionalExperience",
      placeholder: "Professional Experience",
      type: "text",
      name: "professionalexperience",
    },
    {
      id: "yearsOfExperience",
      placeholder: "Years of Experience",
      type: "text",
      name: "yearsofexperience",
    },
    {
      id: "areasOfSpecialization",
      placeholder: "Areas of Specialization",
      type: "text",
      name: "areasofspecialization",
    },
    {
      id: "currentEmployer",
      placeholder: "Current Employer/Practice Name",
      type: "text",
      name: "currentemployer",
    },
    {
      id: "previousEmployers",
      placeholder: "Previous Employers (last 5 years)",
      type: "text",
      name: "previousemployers",
    },
  ];

  const supportingDocumentsFields = [
    {
      id: "certificateOfIncorporation",
      name: "Certificate of Incorporation",
      label: "Certificate of Incorporation",
    },
    {
      id: "memorandumArticles",
      name: "Memorandum and Articles of Association",
      label: "Memorandum and Articles of Association",
    },
    {
      id: "annualReport",
      name: "Recent Annual Report or Financial Statement",
      label: "Recent Annual Report or Financial Statement",
    },
    {
      id: "proofofidentity ",
      name: "Proof of Identity of Partners/Owners ",
      label:
        "IProof of Identity of Partners/Owners (e.g., Passport, National ID)",
    },
    {
      id: "proofOfAddress",
      name: "Proof of Address",
      label: "Proof of Address of Firm (e.g., Utility Bill, Bank Statement)",
    },
    {
      id: "taxComplianceCertificate",
      name: "Tax Compliance Certificate",
      label: "Tax Compliance Certificate (if applicable)",
    },
    {
      id: "amlPolicyDocument",
      name: "AML Policy Document",
      label: "AML Policy Document (if applicable)",
    },
    {
      id: "professionalregistrationcertificate",
      name: "Professional Registration Certificate",
      label: "Professional Registration Certificate",
    },
  ];

  return {
    firmFieldsData,
    firmTypeOptions,
    businessInfoFields,
    operationalInfo,
    ownerInfoFields,
    directorInfoFields,
    taxInfoFields,
    bankingInfoFields,
    registrationInfoFields,
    supportingDocumentsFields
  };
};
